<template>
  <div 
    class="  px-10 mt-12">
    <v-dialog v-model="dialog.customer"
      @keydown.esc="dialog.customer = false"
      :fullscreen="dialog.fullscreen"
      width="1200"
      persistent
      scrollable>
      <v-card 
        :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius-card'"
        class="pa-8 pt-6">
        <v-card-title 
          class="d-flex align-center pa-0 pb-4 text-right popup-header fs-20 font-weight-bold">
          
          Tambahkan Produk

          <v-spacer/>

          <!-- <v-icon 
            @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
            class="cursor-pointer mr-1"
            size="24"
            color="#718EBF">
            {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
          </v-icon>

          <v-icon 
            @click="dialog.customer = false; dialog.fullscreen = false; selected.delete = [];"
            class="cursor-pointer"
            size="24"
            color="red">
            mdi-close-circle-outline
          </v-icon> -->

          <v-icon 
            @click="dialog.customer = false;"
            class="cursor-pointer"
            size="18"
            color="#000000">
            mdi-close
          </v-icon>
        </v-card-title>

        <v-card-text class="mt-3">
          <div 
            class="fs-15 label-input">
            Nama Product
          </div>

          <v-autocomplete
            
            filled
            rounded
            dense
            solo
            v-on:change="addVarian()"

            color="#718EBF"
            placeholder="Nama Product"

            
            :items="product"
            item-value="id"
            item-text="name"
            :item-color="set_color"

            v-model="product_id"
            style="border-radius: 10px;">
          </v-autocomplete>
          <v-data-table
            v-model="selected"
            :headers="headers"
            ref="table-grid"
            class="table-grid"
            :items="list"
            height="calc( 100vh - 400px )"
            elevation="0"
            hide-default-footer
            :single-select="false"
            item-key="id"
            show-select
            :items-per-page="1000000000"
            style="border: 1px solid #E7E7E7;"
          >
          </v-data-table>
        </v-card-text>
        

        <v-card-actions
          class="pa-0 pt-4">
          <v-spacer/>

          <v-btn
            rounded
            @click="toAdd()"
            :loading="process.delete"
            width="190"
            height="45"
            elevation="0"
            color="#1814F3"
            class="fs-16 white--text text-capitalize border-radius">
            Pilih
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-layout wrap>
      <v-flex>
        <section>
          
          <div class="color-dark-blue fs-22 font-weight-bold">
            Tambahkan Order
          </div>

          <v-row
            class="">
            <v-col 
              cols="10"
              class="px-0">
              <v-card 
                flat
                style="background: transparent;">
                <v-card-text>
                  <ValidationObserver 
                    ref="form">
                    <v-form>
                      <!-- <div
                        class="mb-4">
                        <div 
                          class="body-2 mb-2">
                          Poto Profil
                        </div>

                        <uploadfolder v-if="form.image_url === ''"
                          v-model="upload.image">
                          <div 
                            slot="activator">
                            <v-card 
                              flat
                              width="200"
                              height="200"
                              class="d-flex align-center justify-center cursor-pointer"
                              style="border-radius: 15px;
                                    border: 2px solid #EBEBEB; 
                                    border-style: dashed;">
                              <v-avatar v-if="!process.image"
                                v-ripple
                                tile 
                                width="200"
                                height="200">
                                <v-icon
                                  size="50"
                                  color="#B9B9B9">
                                  mdi-cloud-upload-outline
                                </v-icon>
                              </v-avatar>

                              <v-progress-circular v-else
                                indeterminate
                                :color="set_color">
                              </v-progress-circular>
                            </v-card>
                          </div>
                        </uploadfolder>

                        <v-card v-if="form.image_url !== ''"
                          flat
                          width="200"
                          height="200"
                          class="d-flex align-center justify-center"
                          style="border-radius: 15px;
                                border: 2px solid #EBEBEB; 
                                border-style: dashed;">
                          <v-avatar
                            v-ripple
                            tile 
                            size="200"
                            style="border-radius: 15px;">
                            <v-img 
                              contain
                              width="100%"
                              height="100%"
                              alt="Mitra Warung" 
                              :src="form.image_url"
                              class="ma-auto"
                              style="border-radius: 15px;">
                              <template v-slot:placeholder>
                                <v-row
                                  class="fill-height"
                                  align="center"
                                  justify="center">
                                  <v-progress-circular 
                                    indeterminate 
                                    :color="set_color">
                                  </v-progress-circular>
                                </v-row>
                              </template>
                            </v-img>
                          </v-avatar>

                          <v-icon 
                            @click="form.image_url = ''"
                            color="red"
                            class="cursor-pointer"
                            style="position: absolute; top: -10px; right: -10px;">
                            mdi-close-circle
                          </v-icon>
                        </v-card>
                      </div> -->

                      <v-row>
                        <v-col cols="12">
                          <ValidationProvider
                            name="Customer" 
                            rules="required" 
                            v-slot="{ errors }">
                            <div 
                              class="fs-15 label-input">
                              Nama Sales
                            </div>
      
                            <v-autocomplete
                              v-on:keydown.enter.prevent="save()"
                              
                              filled
                              rounded
                              dense
                              solo
      
                              color="#718EBF"
                              placeholder="Nama Sales"
                              v-on:change="changeSales()"
      
                              
                              :items="sales"
                              item-value="id"
                              item-text="name"
                              :item-color="set_color"
      
                              v-model="form.sales_id"
                              :error-messages="errors"
                              required
                              style="border-radius: 10px;">
                            </v-autocomplete>
                          </ValidationProvider>
                        </v-col>

                        <v-col cols="12">
                          <ValidationProvider
                            name="Customer" 
                            rules="required" 
                            v-slot="{ errors }">
                            <div 
                              class="fs-15 label-input">
                              Nama Customer
                            </div>
      
                            <v-autocomplete
                              v-on:keydown.enter.prevent="save()"
                              
                              filled
                              rounded
                              dense
                              solo
      
                              color="#718EBF"
                              placeholder="Nama Customer"
                              v-on:change="changeCustomer()"
      
                              
                              :items="customer"
                              item-value="id"
                              item-text="name"
                              :item-color="set_color"
      
                              v-model="form.customer_id"
                              :error-messages="errors"
                              required
                              style="border-radius: 10px;">
                            </v-autocomplete>
                          </ValidationProvider>
                        </v-col>

<!--                         
                        <v-col
                        cols="12"
                        md="6" class="pt-0 pl-8">


                          <ValidationProvider
                            name="Provinsi" 
                            rules="required" 
                            v-slot="{ errors }">
                            <div class="body-2 mb-2">
                              Provinsi
                            </div>

                            <v-autocomplete
                              v-on:keyup.enter="save()"
                              
                              filled
                              rounded
                              dense
                              v-on:change="changeProvince()"
                              solo

                              :color="set_color"
                              placeholder="Provinsi"

                              :items="province"
                              item-value="name"
                              item-text="name"
                              :item-color="set_color"

                              v-model="form.province_name"
                              :error-messages="errors"
                              required
                              class="mb-6"
                              style="border-radius: 10px;">
                            </v-autocomplete>
                          </ValidationProvider>

                          <ValidationProvider
                            name="Kota/ Kabpaten" 
                            rules="required" 
                            v-slot="{ errors }">
                            <div class="body-2 mb-2">
                              Kota/ Kabpaten
                            </div>

                            <v-autocomplete
                              v-on:keyup.enter="save()"
                              
                              filled
                              rounded
                              dense
                              v-on:change="changeCity()"
                              solo

                              :color="set_color"
                              placeholder="Kota/ Kabpaten"

                              :items="city"
                              item-value="name"
                              item-text="name"
                              :item-color="set_color"

                              v-model="form.city_name"
                              :error-messages="errors"
                              required
                              class="mb-6"
                              style="border-radius: 10px;">
                            </v-autocomplete>
                          </ValidationProvider>


                          <ValidationProvider
                            name="Kecamatan" 
                            rules="required" 
                            v-slot="{ errors }">
                            <div class="body-2 mb-2">
                              Kecamatan
                            </div>

                            <v-autocomplete
                              v-on:keyup.enter="save()"
                              
                              filled
                              rounded
                              dense
                              v-on:change="changeSub()"
                              solo

                              :color="set_color"
                              placeholder="Kecamatan"

                              :items="subdistrict"
                              item-value="name"
                              item-text="name"
                              :item-color="set_color"

                              v-model="form.subdistrict_name"
                              :error-messages="errors"
                              required
                              class="mb-6"
                              style="border-radius: 10px;">
                            </v-autocomplete>
                          </ValidationProvider>


                          <ValidationProvider
                            name="Kelurahan" 
                            rules="required" 
                            v-slot="{ errors }">
                            <div class="body-2 mb-2">
                              Kelurahan
                            </div>

                            <v-autocomplete
                              v-on:keyup.enter="save()"
                              
                              filled
                              rounded
                              dense
                              solo

                              :color="set_color"
                              placeholder="Kelurahan"

                              :items="village"
                              item-value="name"
                              item-text="name"
                              :item-color="set_color"

                              v-model="form.village_name"
                              :error-messages="errors"
                              required
                              class="mb-6"
                              style="border-radius: 10px;">
                            </v-autocomplete>
                          </ValidationProvider>
        
                          <ValidationProvider
                            name="Alamat" 
                            rules="required" 
                            v-slot="{ errors }">
                            <div 
                              class="fs-15 label-input">
                              Alamat
                            </div>
        
                            <v-textarea
                              v-on:keydown.enter.prevent="save()"
                              
                              filled
                              rounded
                              dense
                              solo
        
                              color="#718EBF"
                              placeholder="Alamat"
                              row="3"
        
                              
        
                              v-model="form.address"
                              :error-messages="errors"
                              required
                              style="border-radius: 10px;">
                            </v-textarea>
                          </ValidationProvider>


                        </v-col>

                        <v-col
                          cols="12"
                          class="py-0">
                          <label>
                            AutoComplete
                            <gmap-autocomplete
                              placeholder="ketik alamat"
                              class="v-input__slot"
                              @place_changed="setPlace">
                            </gmap-autocomplete>
                          </label>

                          <div>
                            <gmap-map
                              :center="center"
                              :zoom="12"
                              :options="{
                                zoomControl: true,
                                mapTypeControl: false,
                                scaleControl: false,
                                streetViewControl: false,
                                rotateControl: false,
                                fullscreenControl: true,
                                disableDefaultUi: false
                              }"
                              :clickable="true"
                              @click="updatePlace"
                              style="width: 100%; height: 700px;">

                              <gmap-marker
                                :position="center"
                                :draggable="true"
                                @drag="updatePlace"
                                @click="center = center">
                              </gmap-marker>
                            </gmap-map>
                          </div>
                        </v-col>

                        <v-col
                          cols="12"
                          md="6"
                          class="pt-6">
                          <ValidationProvider 
                            name="Latitude" 
                            rules="required" 
                            v-slot="{ errors }">
                            <div class="fs-15 label-input">

                              Latitude
                            </div>

                            <v-text-field
                              v-on:keyup.enter="save()"
                              
                              filled
                              rounded
                              dense
                              solo
                              readonly

                              onkeypress="return event.charCode >= 45 && event.charCode <= 57"
                              type="number"
                              min="0"

                              :color="set_color"
                              placeholder="Contoh. -2.9198476"

                              v-model="form.latitude"
                              :error-messages="errors"
                              required
                              style="border-radius: 10px;">
                            </v-text-field>
                          </ValidationProvider>
                        </v-col>

                        <v-col
                          cols="12"
                          md="6"
                          class="pt-6">
                          <ValidationProvider 
                            name="Longitude" 
                            rules="required" 
                            v-slot="{ errors }">
                            <div class="fs-15 label-input">

                              Longitude
                            </div>

                            <v-text-field
                              v-on:keyup.enter="save()"
                              
                              filled
                              rounded
                              dense
                              solo
                              readonly

                              onkeypress="return event.charCode >= 45 && event.charCode <= 57"
                              type="number"
                              min="0"

                              :color="set_color"
                              placeholder="Contoh. 104.645729"


                              v-model="form.longitude"
                              :error-messages="errors"
                              required
                              style="border-radius: 10px;">
                            </v-text-field>
                          </ValidationProvider>
                        </v-col> -->

                        <v-col
                          cols="12"
                          md="12" class="pt-0">

                          <div class="d-flex align-center">
                            <div>
                              Data Varian Produk
                            </div>
                            <div class="ml-auto">
                              <v-btn
                                color="#1814F3"
                                width="195"
                                small
                                height="35"
                                elevation="0"
                                style="border-radius: 9px;"
                                @click="openDialog()"
                                class="fs-14 white--text text-capitalize">
                                <v-icon size="18" class="mr-1 pt-1">mdi-plus</v-icon>
                                Tambah Produk
                              </v-btn>
                            </div>
                          </div>
                          <v-divider class="my-2"></v-divider>

                          <v-card flat
                            v-if="form.varian_arr.length < 1">
                            <v-card-text
                              class="pb-0 my-4" style="height: calc( 100vh - 350px ); display: flex; align-items: center; justify-content: center;">
                              <div class="text-center">
                                <v-img 
                                  class="mx-auto"
                                  contain
                                  alt="vuetify"
                                  :width="90"
                                  :height="90"
                                  :src="require('@/assets/image/empty.png')">
                                  <!-- <template v-slot:placeholder>
                                    <v-row
                                      class=" "
                                      align="center"
                                      justify="center">
                                      <v-progress-circular 
                                        indeterminate 
                                        :color="set_color">
                                      </v-progress-circular>
                                    </v-row>
                                  </template> -->
                                </v-img>
                                <div class="mt-3 fs-18">
                                  Belum Ada Produk
                                </div>
                              </div>
                            </v-card-text>

                            <!-- <v-card-text
                              v-else
                              class="pb-0 my-4" style="height: calc( 100vh - 350px );">
                              <v-data-table
                                v-model="form.varian_arr"
                                :headers="configHeaders"
                                :items="form.varian_arr"
                                ref="table-grid"
                                class="table-grid"
                                height="calc( 100vh - 350px )"
                                elevation="0"
                                hide-default-footer
                                :single-select="false"
                                item-key="id"
                                :items-per-page="1000000000"
                              >
                              <template
                                  v-for="header in configHeaders.filter((header) => header.hasOwnProperty('format'))"
                                  v-slot:[`item.${header.value}`]="{ value }">
                                <div
                                  v-bind:key="header.value">
                                  <div v-if="header.format !== 'regex' && header.format !== 'image' && header.format !== 'image_potrait' && header.format !== 'image_landscape' && header.format !== 'action' && header.format !== 'bool' && header.format !== 'status' && header.format !== 'link'">
                                    {{ rowFormat(header.format, value) }} 
                                  </div>
                
                                  <div v-if="header.format === 'link'"
                                    class="cursor-pointer">
                                    
                                  </div>
                    
                                  <div v-if="header.format === 'regex'">
                                    <span
                                      class="two-line">
                                      {{ rowFormat(header.format, value) }}
                                    </span>
                                  </div>
                    
                                  <div v-if="header.format === 'image'"
                                    class="ma-4">
                                    <v-avatar
                                      size="60"
                                      tile
                                      style="border: 2px dashed #e0e0e0; border-radius: 8px !important;">
                                      <v-img 
                                        contain
                                        width="100%"
                                        height="100%"
                                        alt="Mitra Warung" 
                                        :src="value !== '' ? value : require('@/assets/image/image_default.png')"
                                        class="ma-auto">
                                        <template v-slot:placeholder>
                                          <v-row
                                            class="fill-height"
                                            align="center"
                                            justify="center">
                                            <v-progress-circular 
                                              size="20"
                                              indeterminate 
                                              color="#718EBF">
                                            </v-progress-circular>
                                          </v-row>
                                        </template>
                                      </v-img>
                                    </v-avatar>
                                  </div>
                
                                  <div v-if="header.format === 'image_potrait'"
                                    class="ma-4">
                                    <v-img 
                                      contain
                                      width="100"
                                      height="125"
                                      alt="Mitra Warung" 
                                      :src="value !== '' ? value : require('@/assets/image/image_default.png')"
                                      class="ma-auto"
                                      style="border: 2px dashed #e0e0e0; border-radius: 8px !important;">
                                      <template v-slot:placeholder>
                                        <v-row
                                          class="fill-height"
                                          align="center"
                                          justify="center">
                                          <v-progress-circular 
                                            size="20"
                                            indeterminate 
                                            color="#718EBF">
                                          </v-progress-circular>
                                        </v-row>
                                      </template>
                                    </v-img>
                                  </div>
                
                                  <div v-if="header.format === 'image_landscape'"
                                    class="ma-4">
                                    <v-img 
                                      contain
                                      width="200"
                                      height="125"
                                      alt="Mitra Warung" 
                                      :src="value !== '' ? value : require('@/assets/image/image_default.png')"
                                      class="ma-auto"
                                      style="border: 2px dashed #e0e0e0; border-radius: 8px !important;">
                                      <template v-slot:placeholder>
                                        <v-row
                                          class="fill-height"
                                          align="center"
                                          justify="center">
                                          <v-progress-circular 
                                            size="20"
                                            indeterminate 
                                            color="#718EBF">
                                          </v-progress-circular>
                                        </v-row>
                                      </template>
                                    </v-img>
                                  </div>
                
                                  <div v-if="header.format === 'action'">

                                    <v-tooltip 
                                      top>
                                      <template v-slot:activator="{ on, attrs }">
                                        <v-btn
                                        
                                          @click="form.varian_arr.splice(index, 1)"

                                          v-bind="attrs"
                                          v-on="on"

                                          min-width="28"
                                          small
                                          rounded
                                          color="red"
                                          elevation="0"
                                          class="white--text text-capitalize mx-1 px-0"
                                          style="font-weight: 600; border-radius: 6px;">
                                          <v-icon small>mdi-trash-can-outline</v-icon>
                                        </v-btn>
                                      </template>
                                      
                                      <span>Hapus</span>
                                    </v-tooltip>
                                  </div>
                
                                  <div v-if="header.format === 'status'"
                                    class="d-flex justify-start text-capitalize font-weight-medium" :class="value == 'Publish' ? 'blue--text text--darken-2' : 'red--text'">
                                    {{ value }}
                                  </div>
                                </div>
                              </template>
                              <template v-slot:[`item.index`]="{ index }">
                                {{ lastIndex + index }}
                              </template>
                              </v-data-table>
                            </v-card-text> -->
                          </v-card>

                          <div v-else>

                            <div v-for="(item, index) in form.varian_arr" :key="index">
                              <v-card flat class="mb-5">
                                <v-card-text>
                                  <div class="fs-16 font-weight-bold label-input">
                                    {{ item.name }}
                                  </div>
                                  <div>
                                    <span>Kode SKU</span>: <span>{{ item.sku }}</span>
                                  </div>
                                  <div>
                                    <span>Harga</span>: <span>{{ item.price | price }}</span>
                                  </div>

                                  <v-row>
                                    <v-col cols="2">
                                      <div class="fs-14 label-input">
                                        <!-- <span class="red--text">*</span> -->
                                        Harga
                                      </div>
              
                                      <div class="fs-18 font-weight-bold label-input mt-6">
                                        {{ item.price | price }}
                                      </div>
                                    </v-col>

                                    <v-col cols="3">
                                      <ValidationProvider
                                        :name="`Qty ${item.name}`" 
                                        rules="required|min_value:0" 
                                        v-slot="{ errors }">
                                        <div 
                                          class="fs-14 label-input">
                                          Qty
                                        </div>
                  
                                        <v-currency-field
                                        
                                          filled
                                          rounded
                                          dense
                                          solo
                    
                                          color="#718EBF"
                                          placeholder="Qty"
                                          v-on:change="changePcs(index)"

                                          
                    
                                          v-model="item.qty_pcs"
                                          :error-messages="errors"
                                          required
                                          style="border-radius: 10px;">
                                        </v-currency-field>
                                      </ValidationProvider>
                                      <!-- <div class="fs-15 label-input">
                                        Qty
                                      </div>
              
                                      <v-currency-field
                                        
                                        filled
                                        rounded
                                        dense
                                        solo
                  
                                        color="#718EBF"
                                        placeholder="Qty"

                                        
                  
                                        v-model="item.qty"
                                        required
                                        style="border-radius: 10px;">
                                      </v-currency-field> -->
                                    </v-col>
                                    <v-col class="text-right">
                                      <div class="fs-14 label-input">
                                        <!-- <span class="red--text">*</span> -->
                                        Total
                                      </div>
              
                                      <div class="fs-18 font-weight-bold label-input mt-6">
                                        {{ item.price_pcs | price }}
                                      </div>
                                    </v-col>

                                    <!-- <v-col>
                                      <div class="fs-15 label-input">
                                        Harga Beli
                                      </div>
              
                                      <v-currency-field
                                        
                                        filled
                                        rounded
                                        dense
                                        solo
                  
                                        color="#718EBF"
                                        placeholder="Harga Beli"
                                        
                  
                                        v-model="item.harga_beli"
                                        required
                                        style="border-radius: 10px;">
                                      </v-currency-field>
                                    </v-col>

                                    <v-col>
                                      <div class="fs-15 label-input">
                                        PPN Beli
                                      </div>
              
                                      <v-currency-field
                                        
                                        filled
                                        rounded
                                        dense
                                        solo
                  
                                        color="#718EBF"
                                        placeholder="PPN Beli"
                                        
                  
                                        v-model="item.ppn_beli"
                                        required
                                        style="border-radius: 10px;">
                                      </v-currency-field>
                                    </v-col> -->
                                  </v-row>

                                  <v-row>
                                    <v-col cols="2">
                                      <div class="fs-14 label-input">
                                        <!-- <span class="red--text">*</span> -->
                                        Harga
                                      </div>
              
                                      <div class="fs-18 font-weight-bold label-input mt-6">
                                        {{ item.price | price }}
                                      </div>
                                    </v-col>

                                    <v-col cols="3">
                                      <ValidationProvider
                                        :name="`Qty ${item.name}`" 
                                        rules="required|min_value:0" 
                                        v-slot="{ errors }">
                                        <div 
                                          class="fs-14 label-input">
                                          Qty Lusin
                                        </div>
                  
                                        <v-currency-field
                                        
                                          filled
                                          rounded
                                          dense
                                          solo
                    
                                          color="#718EBF"
                                          placeholder="Qty"
                                          v-on:change="changeLusin(index)"

                                          
                    
                                          v-model="item.qty_lusin"
                                          :error-messages="errors"
                                          required
                                          style="border-radius: 10px;">
                                        </v-currency-field>
                                      </ValidationProvider>
                                      <!-- <div class="fs-15 label-input">
                                        Qty
                                      </div>
              
                                      <v-currency-field
                                        
                                        filled
                                        rounded
                                        dense
                                        solo
                  
                                        color="#718EBF"
                                        placeholder="Qty"

                                        
                  
                                        v-model="item.qty"
                                        required
                                        style="border-radius: 10px;">
                                      </v-currency-field> -->
                                    </v-col>
                                    <v-col class="text-right">
                                      <div class="fs-14 label-input">
                                        <!-- <span class="red--text">*</span> -->
                                        Total
                                      </div>
              
                                      <div class="fs-18 font-weight-bold label-input mt-6">
                                        {{ item.price_lusin | price }}
                                      </div>
                                    </v-col>

                                    <!-- <v-col>
                                      <div class="fs-15 label-input">
                                        Harga Beli
                                      </div>
              
                                      <v-currency-field
                                        
                                        filled
                                        rounded
                                        dense
                                        solo
                  
                                        color="#718EBF"
                                        placeholder="Harga Beli"
                                        
                  
                                        v-model="item.harga_beli"
                                        required
                                        style="border-radius: 10px;">
                                      </v-currency-field>
                                    </v-col>

                                    <v-col>
                                      <div class="fs-15 label-input">
                                        PPN Beli
                                      </div>
              
                                      <v-currency-field
                                        
                                        filled
                                        rounded
                                        dense
                                        solo
                  
                                        color="#718EBF"
                                        placeholder="PPN Beli"
                                        
                  
                                        v-model="item.ppn_beli"
                                        required
                                        style="border-radius: 10px;">
                                      </v-currency-field>
                                    </v-col> -->
                                  </v-row>

                                  <v-row>
                                    <v-col cols="2">
                                      <div class="fs-14 label-input">
                                        <!-- <span class="red--text">*</span> -->
                                        Harga
                                      </div>
              
                                      <div class="fs-18 font-weight-bold label-input mt-6">
                                        {{ item.price | price }}
                                      </div>
                                    </v-col>

                                    <v-col cols="3">
                                      <ValidationProvider
                                        :name="`Qty ${item.name}`" 
                                        rules="required|min_value:0" 
                                        v-slot="{ errors }">
                                        <div 
                                          class="fs-14 label-input">
                                          Qty Dus <span class="fs-11">*(1 dus = {{ item.total_in_dus }} Pcs)</span>
                                        </div>
                  
                                        <v-currency-field
                                        
                                          filled
                                          rounded
                                          dense
                                          solo
                    
                                          color="#718EBF"
                                          placeholder="Qty"
                                          v-on:change="changeDus(index)"

                                          
                    
                                          v-model="item.qty_dus"
                                          :error-messages="errors"
                                          required
                                          style="border-radius: 10px;">
                                        </v-currency-field>
                                      </ValidationProvider>
                                      <!-- <div class="fs-15 label-input">
                                        Qty
                                      </div>
              
                                      <v-currency-field
                                        
                                        filled
                                        rounded
                                        dense
                                        solo
                  
                                        color="#718EBF"
                                        placeholder="Qty"

                                        
                  
                                        v-model="item.qty"
                                        required
                                        style="border-radius: 10px;">
                                      </v-currency-field> -->
                                    </v-col>
                                    <v-col class="text-right">
                                      <div class="fs-14 label-input">
                                        <!-- <span class="red--text">*</span> -->
                                        Total
                                      </div>
              
                                      <div class="fs-18 font-weight-bold label-input mt-6">
                                        {{ item.price_dus | price }}
                                      </div>
                                    </v-col>

                                    <!-- <v-col>
                                      <div class="fs-15 label-input">
                                        Harga Beli
                                      </div>
              
                                      <v-currency-field
                                        
                                        filled
                                        rounded
                                        dense
                                        solo
                  
                                        color="#718EBF"
                                        placeholder="Harga Beli"
                                        
                  
                                        v-model="item.harga_beli"
                                        required
                                        style="border-radius: 10px;">
                                      </v-currency-field>
                                    </v-col>

                                    <v-col>
                                      <div class="fs-15 label-input">
                                        PPN Beli
                                      </div>
              
                                      <v-currency-field
                                        
                                        filled
                                        rounded
                                        dense
                                        solo
                  
                                        color="#718EBF"
                                        placeholder="PPN Beli"
                                        
                  
                                        v-model="item.ppn_beli"
                                        required
                                        style="border-radius: 10px;">
                                      </v-currency-field>
                                    </v-col> -->
                                  </v-row>

                                  <v-divider class="my-4"></v-divider>

                                  <v-row>
                                    <v-col class="label-input font-weight-bold ">
                                      <div>
                                        Sub Total
                                      </div>
                                    </v-col>
                                    <v-col cols="12" md="4">
                                      <div>
                                        
                                      </div>
                                    </v-col>
                                    <v-col cols="12" md="4" class="text-right">
                                      <div class="fs-19 font-weight-bold label-input">
                                        {{ item.sub_total | price }}
                                      </div>
                                    </v-col>
                                  </v-row>

                                </v-card-text>
                              </v-card>
                            </div>

                            <v-divider class="my-4"></v-divider>

                            <div>
                              <v-card flat>
                                <v-card-text>
                                  <v-row>
                                    <v-col cols="12" md="4">
                                      <div class="label-input font-weight-bold ">
                                        Grand Total
                                      </div>
                                    </v-col>
                                    <v-col cols="12" md="4">
                                      <div>
                                        
                                      </div>
                                    </v-col>
                                    <v-col cols="12" md="4" class="text-right">
                                      <div class="fs-19 font-weight-bold label-input">
                                        {{ grand_total | price }}
                                      </div>
                                    </v-col>
                                  </v-row>
                                </v-card-text>
                              </v-card>
                            </div>


                          </div>
                        </v-col>

                      </v-row>



                    </v-form>
                  </ValidationObserver>

                  <div v-if="message.error.length > 0"
                    class="text-center my-4 d-flex align-center">
                    <div
                      class="error--text">
                      <v-icon size="18" color="red">mdi-alert-circle-outline</v-icon>
                      
                      <span
                        class="ml-1">
                        {{ message.error }}
                      </span>
                    </div>
                  </div>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>

          <v-row
            justify="end"
            class="pa-4 pr-1">
            <v-col 
              cols="12"
              md="12"
              class="d-flex align-center justify-end py-0">
              <v-btn 
                @click="save()"
                :loading="process.form"
                :disabled="process.form"
                width="190"
                height="45"
                elevation="0"
                color="#1814F3"
                class="fs-16 white--text text-capitalize border-radius">
                Simpan
              </v-btn>
              
              <v-btn
                @click="$router.go(-1)"
                :disabled="process.form"
                color="red"
                elevation="0"
                width="140"
                height="45"
                class="body-2 white--text text-capitalize d-flex align-center ml-4 border-radius"
                style="font-weight: 600;">
              
                  Batal
              </v-btn>
            </v-col>
          </v-row>
        </section>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import { get, post, put, patch, destroy } from "@/service/Axios";
  import moment from "moment"
  import "moment/locale/id"
  export default {
    data () {
      return {
        dialog: {
          customer: false,
          fullscreen: false
        },
        markers: [],
        sales: [],
      place: null,
        form: {
          id: '',
          customer_id: '',
          sales_id: '',
          sales_name: '',
          address: '',
          latitude: '-2.9198476',
          longitude: '104.645729',
          varian_arr: [],
          province: '',
          city: '',
          subdistrict: '',
          village: '',
        },
        sales_region_id: '',
        product: [],
        product_id: '',
        selected: [],
        headers: [
                // {
                //   text: 'No',
                //   width: '80',
                //   value: 'index',
                //   freeze: true,
                //   hide: false
                // },
                {
                  text: 'Nama',
                  width: '150px',
                  value: 'name',
                  freeze: true,
                  hide: false
                },
                {
                  text: 'SKU',
                  width: '180px',
                  value: 'sku',
                  freeze: false,
                  hide: false
                },
              
              ],

        list: [],
        province: [],
        city: [],
        subdistrict: [],
        village: [],
        customer: [],
        sales: [],
        menu: ['Koordinat', 'Polygon'],
        grand_total: 0,

        // selected: {
        //   row: [],
        //   freeze: [],
        //   delete: [],

        //   menu: 'Koordinat'
        // },

        map: null,

        center: {
          lat: -2.9198476, 
          lng: 104.645729
        },

        upload: {
          images: null
        },

        process: {
          form: false,

          file: false
        },
        
        message: {
          success: '',
          error: ''
        }
      }
    },
    components: {
      uploadfolder: () => import(/* webpackPrefetchCategory: true */ '@/components/upload/folder.vue')
    },
    watch: {
      'upload.images': {
        handler: function () {
          if (this.upload.images) {
            this.process.images = this.upload.images.process

            if (!this.process.images) {
              // CALLBACK FROM UPLOAD IMAGE
              
              // this.form.images = this.upload.images.fileuri
              // this.upload.images.map(obj => {
                this.form.images.push(
                  this.upload.images.fileuri
                )
              // })

              // this.save_image()
            }
          }
        },
        deep: true
      }
    },
    computed: {
      user () {
        return this.$store.state.user
      },
      rps () {
        return this.$vuetify.breakpoint.name
      },
      fcm () {
        return this.$store.state.fcm
      },
      isDay () {
        let hours = (new Date()).getHours(),
            day = hours >= 5 && hours <= 8 ? 'pagi' : hours > 8 && hours <= 14 ? 'siang' : hours > 14 && hours <= 18 ? 'sore' : 'malam'
        return day
      },
      set_color () {
        return this.$store.state.color
      },
      set_color_rgb () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.97)`
      },
      set_color_rgb_up () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g+30}, ${b+30}, 0.97)`
      },
      set_color_rgb_down () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.25)`
      }
    },
    mounted () {
      this.fetchSales()
      this.fetchProv()
    },
    methods: {
      async fetchProduct () {
        this.process.load = true

        let params = {
          limit: 1000000,
          sales_id: this.form.sales_id
          // limit: 1000000,
          // par_id: '1'
        }

        await get(`admin/order/product`, { params })
        .then(response => {
          let res = response.data
            
          if (res.status === 200) {
            this.product = res.results.data
            
          }
          this.process.load = false
        })
      },
      setDescription(description) {
        this.description = description;
      },
      setPlace(place) {
        this.place = place
        this.center = {
          lat: this.place.geometry.location.lat(),
          lng: this.place.geometry.location.lng(),
        
        }
          this.initMap()
        this.form.latitude = this.place.geometry.location.lat()
        this.form.longitude = this.place.geometry.location.lng()
      },
      async fetchCustomer() {

         let params = {
          limit: 10000000000000,
          sales_region_id: this.sales_region_id
        }

        await get(`admin/customer/data`, { params })
        .then(response => {
          let res = response.data
          
          if (res.status === 200) {
            this.customer = res.results.data
          }
        })
      },
      addVarian() {
        let list = []
        this.list = []
        this.product.map(obj => {
          if (obj.id === this.product_id) {
            list = obj.varian
          }
        })

        list.map((item) => {
          this.list.push({
            ...item,
            images: item.images.length < 1 ? [] : JSON.parse(item.images),
            qty_pcs: 0, 
            qty_dus: 0, 
            qty_lusin: 0, 
            price_pcs: 0, 
            price_dus: 0, 
            price_lusin: 0,
            sub_total: 0
          })
        })
      },
      changePcs(index) {
        this.form.varian_arr[index].price_pcs = this.form.varian_arr[index].price * this.form.varian_arr[index].qty_pcs
        this.form.varian_arr[index].sub_total = this.form.varian_arr[index].price_pcs + this.form.varian_arr[index].price_dus + this.form.varian_arr[index].price_lusin
        this.grand_total = this.form.varian_arr.reduce((a, b) => a + (b['sub_total'] || 0), 0)
      },
      changeLusin(index) {
        this.form.varian_arr[index].price_lusin = this.form.varian_arr[index].price * this.form.varian_arr[index].qty_lusin * 12
        this.form.varian_arr[index].sub_total = this.form.varian_arr[index].price_pcs + this.form.varian_arr[index].price_dus + this.form.varian_arr[index].price_lusin
        this.grand_total = this.form.varian_arr.reduce((a, b) => a + (b['sub_total'] || 0), 0)
      },

      changeDus(index) {
        this.form.varian_arr[index].price_dus = this.form.varian_arr[index].price * this.form.varian_arr[index].qty_dus * this.form.varian_arr[index].total_in_dus
        this.form.varian_arr[index].sub_total = this.form.varian_arr[index].price_pcs + this.form.varian_arr[index].price_dus + this.form.varian_arr[index].price_lusin
        this.grand_total = this.form.varian_arr.reduce((a, b) => a + (b['sub_total'] || 0), 0)
      },

      changeSales() {
        this.sales.map(obj => {
          if (obj.id === this.form.sales_id) {
            this.sales_region_id = obj.sales_region_id
            this.form.sales_name = obj.name
          }
        })
        this.fetchProduct()

        this.fetchCustomer()
      },

      changeCustomer() {
        this.customer.map(obj => {
          if (obj.id === this.form.customer_id) {
            // this.sales_region_id = obj.sales_region_id
            this.form.province = obj.province_name
            this.form.city = obj.city_name
            this.form.subdistrict = obj.subdistrict_name
            this.form.village = obj.village_name
            this.form.address = obj.address
            this.form.latitude = obj.latitude
            this.form.longitude = obj.longitude
          }
        })

        // this.fetchCustomor()
      },

      async fetchSales() {

         let params = {
          limit: 10000000000000,
          is_active: 'Aktif',
          'category_user_id[eq]': '8',
        }

        await get(`admin/user/data`, { params })
        .then(response => {
          let res = response.data
          
          if (res.status === 200) {
            this.sales = res.results.data
          }
        })
      },

      async fetchProv() {

         let params = {
          limit: 10000000000000
        }

        await get(`ref/provinsi`, { params })
        .then(response => {
          let res = response.data
          
          if (res.status === 200) {
            this.province = res.results.data
          }
        })
      },

      changeProvince() {
        this.form.city_name = ''
        let id = ''
        this.province.map(obj => {
          if (obj.name === this.form.province_name) {
            id = obj.id
          }
        })
        this.fetchCity(id)
      },

      async fetchCity(id) {

         let params = {
          limit: 10000000000000,
          province_id: id
        }

        await get(`ref/kota`, { params })
        .then(response => {
          let res = response.data
          
          if (res.status === 200) {
            this.city = res.results.data
          }
        })
      },

      changeCity() {
        this.form.subdistrict_name = ''
        let id = ''
        this.city.map(obj => {
          if (obj.name === this.form.city_name) {
            id = obj.id
          }
        })
        this.fetchSub(id)
      },

      async fetchSub(id) {

         let params = {
          limit: 10000000000000,
          city_id: id
        }

        await get(`ref/kecamatan`, { params })
        .then(response => {
          let res = response.data
          
          if (res.status === 200) {
            this.subdistrict = res.results.data
          }
        })
      },

      changeSub() {
        this.form.village_name = ''
        let id = ''
        this.subdistrict.map(obj => {
          if (obj.name === this.form.subdistrict_name) {
            id = obj.id
          }
        })
        this.fetchVil(id)
      },

      async fetchVil(id) {

         let params = {
          limit: 10000000000000,
          subdistrict_id: id
        }

        await get(`ref/kelurahan`, { params })
        .then(response => {
          let res = response.data
          
          if (res.status === 200) {
            this.village = res.results.data
          }
        })
      },
      async fetchVarian () {
          this.list = []
          // this.process.load = true
  
          // this.limit = pagination.row
  
          let params = {
            limit: 10000000000000,
            product_id: this.product_id
          }
  
          // admin/services/data
          
          await get(`admin/varian/data`, { params })
          .then(response => {
            let res = response.data
            
            this.process.load = false
            
            this.list = []
            this.pagination = {}
            
            if (res.status === 200) {
              this.headers = [
                // {
                //   text: 'No',
                //   width: '80',
                //   value: 'index',
                //   freeze: true,
                //   hide: false
                // },
                {
                  text: 'Nama',
                  width: '150px',
                  value: 'name',
                  freeze: true,
                  hide: false
                },
                {
                  text: 'SKU',
                  width: '180px',
                  value: 'sku',
                  freeze: false,
                  hide: false
                },
                {
                  text: 'Produk',
                  width: '200px',
                  value: 'product_name',
                  freeze: false,
                  hide: false
                },
              
              ]

              this.headers_data = [
                {
                  text: 'No',
                  width: '80',
                  value: 'index',
                  freeze: true,
                  hide: false
                },
                {
                  text: 'Nama',
                  width: '300px',
                  value: 'name',
                  freeze: true,
                  hide: false
                },
                {
                  text: 'SKU',
                  width: '180px',
                  value: 'sku',
                  freeze: false,
                  hide: false
                },
                {
                  text: 'Produk',
                  width: '200px',
                  value: 'product_name',
                  freeze: false,
                  hide: false
                },

                {
                  text: '',
                  width: '100px',
                  value: 'id',
                  freeze: true,
                  hide: false,
                  align: 'right',
                  format: 'action'
                },
              
              ]
      

              res.results.data.map((item) => {
                this.list.push({
                  ...item
                })
              })
            }
          })
        },
      openDialog () {
        this.selected = []
        this.selected.push(...this.form.varian_arr)
        this.dialog.customer = true
      },
      toAdd() {
        this.form.varian_arr = []
        this.dialog.customer = false
        this.form.varian_arr.push(...this.selected)
        // this.form.varian_arr = this.selected
      },

      updatePlace (location) {
        this.center = {
          lat: location.latLng.lat(),
          lng: location.latLng.lng()
        }

        this.form.latitude = location.latLng.lat()
        this.form.longitude = location.latLng.lng()
      },

      // INIT MAP
      initMap () {
        let self = this

        this.$gmapApiPromiseLazy().then(() => {
          self.map = new google.maps.Map(document.getElementById('map'), {
            center: { 
              lat: -2.9198476, 
              lng: 104.645729
            },
            zoom: 18,
            noClear: true,
            mapTypeId: 'hybrid', //satellite
            navigationControl: true,
            mapTypeControl: false,
            streetViewControl: false,
            tilt: 0
          })

          self.map.data.addListener('addfeature', self.featureAdded)

          const drawingManager = new google.maps.drawing.DrawingManager({
            drawingMode: google.maps.drawing.OverlayType.POLYGON,
            drawingControl: true,
            drawingControlOptions: {
              position: google.maps.ControlPosition.TOP_LEFT,
              drawingModes: ['polygon']
            },
            polygonOptions: {
              fillColor: '#FF0000',
              fillOpacity: 0.35,
              strokeColor: '#FF0000',
              strokeWeight: 2,
              strokeOpacity: 1,
              draggable: true,
              editable: true,
              clickable: true,
              zIndex: 1
            }
          })

          drawingManager.setMap(self.map)

          drawingManager.addListener('polygoncomplete', (polygon) => {
            if (polygon.getPath().getLength() < 3) {
              console.log('Polygons must have 3 or more points.')

              polygon.getPath().clear()
            } else {
              // self.form.latlong_json_arr = []

              this.set_polygon_complete = true

              self.addFeature('Polygon', polygon.getPath())

              polygon.setMap(null)
            }
          })

          // #JIKA SINGLE POLYGON
          // if (this.form.latlong_json_arr.length > 0) self.addFeature('Polygon', this.form.latlong_json_arr)

          // ======================== SPLIT ======================== \\

          // #JIKA MULTI POLYGON
          if (this.form.latlong_json_arr.length > 0) {
            this.form.latlong_json_arr.forEach(obj => {
              self.addFeature('Polygon', obj.latlng)
            })
          }
        })
      },

      featureAdded (e) {
        switch (e.feature.getGeometry().getType()) {
          case 'Polygon':
            addFeature('Polygon', e.feature.getGeometry().getAt(0).getArray())

            break
        }

        self.map.data.remove(e.feature)
      },

      addFeature (type, path) {
        let self = this

        let index_latlng = ''

        switch (type) {
          case 'Polygon':
            let polygon = new google.maps.Polygon({
              fillColor: '#FF0000',
              fillOpacity: 0.35,
              strokeColor: '#FF0000',
              strokeWeight: 2,
              strokeOpacity: 1,
              draggable: true,
              editable: true,
              clickable: true,
              zIndex: 1
            })

            polygon.setPath(path)

            polygon.addListener('click', (e) => {
              self.form.latlong_json_arr.forEach(obj => {
                obj.latlng.forEach(item => {
                  if(item.lat === e.latLng.lat()) {
                    index_latlng = obj.index
                  }
                })
              })
            })

            polygon.getPath().addListener('insert_at', (e) => {
              // console.log(e)
            })

            polygon.getPath().addListener('set_at', (e, obj) => {
              // self.form.latlong_json_arr[e].lat = obj.lat()
              // self.form.latlong_json_arr[e].lng = obj.lng()

              let polypath = polygon.getPath()

              // #JIKA SINGLE POLYGON
              // self.form.latlong_json_arr = []

              // for (var i = 0; i < polypath.length; i++) {
              //   self.form.latlong_json_arr.push({
              //     lat: polypath.getAt(i).lat(),
              //     lng: polypath.getAt(i).lng()
              //   })
              // }

              // ======================== SPLIT ======================== \\

              // #JIKA MULTI POLYGON
              self.form.latlong_json_arr[index_latlng].latlng = []
              
              for (var i = 0; i < polypath.length; i++) {
                self.form.latlong_json_arr[index_latlng].latlng.push({
                  lat: polypath.getAt(i).lat(),
                  lng: polypath.getAt(i).lng()
                })
              }
            })

            polygon.getPath().addListener('remove_at', (e) => {
              // console.log(e)
            })

            polygon.addListener('dragstart', (e) => {
              // #JIKA SINGLE POLYGON
              // Konten ketika single polygon

              // ======================== SPLIT ======================== \\

              // #JIKA MULTI POLYGON
              let polypath = polygon.getPath()


              self.form.latlong_json_arr.forEach(obj => {
                obj.latlng.forEach(item => {
                  if(item.lat === polypath.getAt(0).lat()) {
                    index_latlng = obj.index
                  }
                })
              })
            })

            polygon.addListener('dragend', (e) => {
              let polypath = polygon.getPath()
              let bounds = new google.maps.LatLngBounds()

              // #JIKA SINGLE POLYGON
              // self.form.latlong_json_arr = []

              // for (var i = 0; i < polypath.length; i++) {
              //   bounds.extend(polypath.getAt(i))

              //   self.form.latlong_json_arr.push({
              //     lat: polypath.getAt(i).lat(),
              //     lng: polypath.getAt(i).lng()
              //   })
              // }

              // let center = bounds.getCenter()
              // stringlocation = JSON.stringify(self.form.latlong_json_arr)
              // stringcenter = JSON.stringify(center)
              // console.log(stringcenter + stringlocation)

              // ======================== SPLIT ======================== \\

              // #JIKA MULTI POLYGON
              self.form.latlong_json_arr[index_latlng].latlng = []

              for (var i = 0; i < polypath.length; i++) {
                bounds.extend(polypath.getAt(i))

                self.form.latlong_json_arr[index_latlng].latlng.push({
                  lat: polypath.getAt(i).lat(),
                  lng: polypath.getAt(i).lng()
                })
              }
            })

            polygon.addListener('rightclick', (e) => {
              // #JIKA SINGLE POLYGON
              // if (e.vertex == undefined) return

              // if (polygon.getPath().getLength() === 3) {
              //   polygon.setMap(null)
                
              //   self.form.latlong_json_arr = []
              // } else {
              //   console.log(index_latlng)
              //   polygon.getPath().removeAt(e.vertex)
              //   self.form.latlong_json_arr.splice(e.vertex, 1)
              // }

              // ======================== SPLIT ======================== \\

              // #JIKA MULTI POLYGON
              self.form.latlong_json_arr.forEach(obj => {
                obj.latlng.forEach(item => {
                  if(item.lat === e.latLng.lat()) {
                    index_latlng = obj.index
                  }
                })
              })

              if (e.vertex == undefined) return

              if (polygon.getPath().getLength() === 3) {
                polygon.setMap(null)
                
                // self.form.latlong_json_arr = []

                self.form.latlong_json_arr.splice(index_latlng, 1)
              } else {
                polygon.getPath().removeAt(e.vertex)
                self.form.latlong_json_arr[index_latlng].latlng.splice(e.vertex, 1)
              }
            })

            let data_polygon = polygon.getPath()

            let before_insert = []

            for (let i = 0; i < data_polygon.getLength(); i++) {
              // #JIKA SINGLE POLYGON
              // self.form.latlong_json_arr.push({
              //   lat: parseFloat(data_polygon.getAt(i).toUrlValue(10).split(',')[0]),
              //   lng: parseFloat(data_polygon.getAt(i).toUrlValue(10).split(',')[1])
              // })

              // const lats = self.form.latlong_json_arr.map(o => o.lat)
              // self.form.latlong_json_arr = self.form.latlong_json_arr.filter(({lat}, index) => !lats.includes(lat, index + 1))

              // ======================== SPLIT ======================== \\

              // #JIKA MULTI POLYGON
              before_insert.push({
                lat: parseFloat(data_polygon.getAt(i).lat()),
                lng: parseFloat(data_polygon.getAt(i).lng())
              })

              const lats = before_insert.map(o => o.lat)
              before_insert = before_insert.filter(({lat}, index) => !lats.includes(lat, index + 1))
            }

            if (before_insert.length > 2 && self.set_polygon_complete) {
              self.form.latlong_json_arr.push({
                index: self.form.latlong_json_arr.length,
                lat: before_insert[0].lat,
                lng: before_insert[0].lng,
                latlng: before_insert
              })

              self.set_polygon_complete = false
            }

            console.log(self.form.latlong_json_arr)

            polygon.setMap(self.map)

            break
        }
      },

      addLatlng () {
        // #JIKA SINGLE POLYGON
        // this.form.latlong_json_arr.push({
        //   lat: null,
        //   lng: null
        // })

        // ======================== SPLIT ======================== \\
        
        // #JIKA MULTI POLYGON
        this.form.latlong_json_arr.push({
          index: this.form.latlong_json_arr.length,
          latlng: [
            {
              lat: null,
              lng: null
            },
            {
              lat: null,
              lng: null
            },
            {
              lat: null,
              lng: null
            }
          ]
        })
      },

      removeLatlng (index) {
        // #JIKA SINGLE POLYGON
        // this.form.latlong_json_arr.splice(index, 1)

        // ======================== SPLIT ======================== \\
        
        // #JIKA MULTI POLYGON
        this.form.latlong_json_arr[index].latlng.splice(index_sub, 1)

        if (this.form.latlong_json_arr[index].latlng.length < 3) {
          this.form.latlong_json_arr.splice(index, 1)
        }

        this.initLatlng()
      },

      initLatlng () {
        let self = this

        if (this.form.latlong_json_arr.length > 2) {
          if (this.form.latlong_json_arr[2].lat !== '' && this.form.latlong_json_arr[2].lat !== null && this.form.latlong_json_arr[2].lng !== '' && this.form.latlong_json_arr[2].lng !== null) {
            this.$gmapApiPromiseLazy().then(() => {
              self.map = new google.maps.Map(document.getElementById('map'), {
                center: { 
                  lat: this.form.latlong_json_arr.length > 0 ? this.form.latlong_json_arr[0].lat : -7.7126396311,
                  lng: this.form.latlong_json_arr.length > 0 ? this.form.latlong_json_arr[0].lng : 110.5909243135
                },
                zoom: 18,
                noClear: true,
                mapTypeId: 'hybrid', //satellite
                navigationControl: true,
                mapTypeControl: false,
                streetViewControl: false,
                tilt: 0
              })
    
              self.map.data.addListener('addfeature', self.featureAdded)
    
              const drawingManager = new google.maps.drawing.DrawingManager({
                drawingMode: this.form.latlong_json_arr.length < 1 ? google.maps.drawing.OverlayType.POLYGON : null,
                drawingControl: true,
                drawingControlOptions: {
                  position: google.maps.ControlPosition.TOP_LEFT,
                  drawingModes: ['polygon']
                },
                polygonOptions: {
                  fillColor: '#FF0000',
                  fillOpacity: 0.35,
                  strokeColor: '#FF0000',
                  strokeWeight: 2,
                  strokeOpacity: 1,
                  draggable: true,
                  editable: true,
                  clickable: true,
                  zIndex: 1
                }
              })
    
              drawingManager.setMap(self.map)
    
              drawingManager.addListener('polygoncomplete', (polygon) => {
                if (polygon.getPath().getLength() < 3) {
                  console.log('Polygons must have 3 or more points.')
                  polygon.getPath().clear()
                } else {
                  self.addFeature('Polygon', polygon.getPath())
                  polygon.setMap(null)
                }
              })
    
              // #JIKA SINGLE POLYGON
              // if (this.form.latlong_json_arr.length > 0) self.addFeature('Polygon', this.form.latlong_json_arr)

              // ======================== SPLIT ======================== \\

              // #JIKA MULTI POLYGON
              if (this.form.latlong_json_arr.length > 0) {
                this.form.latlong_json_arr.forEach(obj => {
                  self.addFeature('Polygon', obj.latlng)
                })
              }
            })
          }
        } else {
          this.initMap()
        }
      },

      async save () {
        this.message.error = ''

        const isValid = await this.$refs.form.validate()
        if (isValid) {
          let form = {
            ...this.form,
            varian_arr: JSON.stringify(this.form.varian_arr.map(item => {
              return {
                varian_id: item.id,
                // varian_sku: item.sku,
                // varian_name: item.name,
                // varian_images: item.images,
                qty_pcs: item.qty_pcs, 
                qty_dus: item.qty_dus, 
                qty_lusin: item.qty_lusin, 
                // price_pcs: item.price_pcs, 
                // price_dus: item.price_dus, 
                // price_lusin: item.price_lusin,
                // total_in_dus: item.total_in_dus,
              }
            }))
          }
          this.process.form = true

          // SAVE TO REST API
          await post(`admin/order/add`, {
            data: form
          })
          .then((response) => {
            let res = response.data

            this.process.form = false

            if (res.status === 200) {

              this.$router.push({ path: '/approval/order' })
              // this.$router.go(-1)

            } else {
              this.message.error = res.message
            }
          })
          
        } else {
          // AUTO FOCUS ON TEXT-FIELD
          setTimeout(() => {
            const errors = Object.entries(this.$refs.form.errors)
              .map(([key, value]) => ({ key, value }))
              .filter(error => error['value'].length)
            this.$refs.form.refs[errors[0]['key']].$el.scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            })
          }, 10)
        }
      }
    }
  }
</script>